// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sidebar_wrapper__2wS2C","navListItems":"sidebar_navListItems__21rrS","navItem":"sidebar_navItem__1Bbsp","navItemActive":"sidebar_navItemActive__1owiC"};